"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS_SCHEDULED = exports.STATUS_PUBLISHED = exports.STATUS_DRAFT = exports.CONTENT_TYPE_QUESTION = exports.CONTENT_TYPE_PRODUCT_UPDATE = exports.CONTENT_TYPE_IDEA = exports.CONTENT_TYPE_DISCUSSION = exports.CONTENT_TYPE_CONVERSATION = exports.CONTENT_TYPE_ARTICLE = void 0;
exports.getConsistentContentType = getConsistentContentType;
exports.getLegacyContentType = getLegacyContentType;
exports.getReadableContentType = getReadableContentType;
exports.isArticle = isArticle;
exports.isConversation = isConversation;
exports.isConversationOrDiscussion = isConversationOrDiscussion;
exports.isDiscussion = isDiscussion;
exports.isIdea = isIdea;
exports.isProductUpdate = isProductUpdate;
exports.isQuestion = isQuestion;
var CONTENT_TYPE_ARTICLE = 'article';
exports.CONTENT_TYPE_ARTICLE = CONTENT_TYPE_ARTICLE;
var CONTENT_TYPE_QUESTION = 'question';
exports.CONTENT_TYPE_QUESTION = CONTENT_TYPE_QUESTION;
var CONTENT_TYPE_DISCUSSION = 'discussion';
exports.CONTENT_TYPE_DISCUSSION = CONTENT_TYPE_DISCUSSION;
var CONTENT_TYPE_CONVERSATION = 'conversation';
exports.CONTENT_TYPE_CONVERSATION = CONTENT_TYPE_CONVERSATION;
var CONTENT_TYPE_IDEA = 'idea';
exports.CONTENT_TYPE_IDEA = CONTENT_TYPE_IDEA;
var CONTENT_TYPE_PRODUCT_UPDATE = 'productUpdate';
exports.CONTENT_TYPE_PRODUCT_UPDATE = CONTENT_TYPE_PRODUCT_UPDATE;

function isArticle(contentType) {
  return contentType === CONTENT_TYPE_ARTICLE;
}

function isQuestion(contentType) {
  return contentType === CONTENT_TYPE_QUESTION;
}

function isDiscussion(contentType) {
  return contentType === CONTENT_TYPE_DISCUSSION;
}

function isConversation(contentType) {
  return contentType === CONTENT_TYPE_CONVERSATION;
}

function isConversationOrDiscussion(contentType) {
  return contentType === CONTENT_TYPE_CONVERSATION || contentType === CONTENT_TYPE_DISCUSSION;
}

function isIdea(contentType) {
  return contentType === CONTENT_TYPE_IDEA;
}

function isProductUpdate(contentType) {
  return contentType === CONTENT_TYPE_PRODUCT_UPDATE;
}

function getConsistentContentType(contentType) {
  return isDiscussion(contentType) ? CONTENT_TYPE_CONVERSATION : contentType;
}

function getReadableContentType(contentType) {
  return getConsistentContentType(contentType) === CONTENT_TYPE_PRODUCT_UPDATE ? 'product update' : contentType;
}

function getLegacyContentType(contentType) {
  return contentType === CONTENT_TYPE_CONVERSATION ? CONTENT_TYPE_DISCUSSION : contentType;
}

var STATUS_PUBLISHED = 'published';
exports.STATUS_PUBLISHED = STATUS_PUBLISHED;
var STATUS_SCHEDULED = 'scheduled';
exports.STATUS_SCHEDULED = STATUS_SCHEDULED;
var STATUS_DRAFT = 'draft';
exports.STATUS_DRAFT = STATUS_DRAFT;